import { render } from "./ShortlistAction.vue?vue&type=template&id=27a8cfa9"
import script from "./ShortlistAction.vue?vue&type=script&lang=js"
export * from "./ShortlistAction.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__